// -- == //
import PanelBoxLayout from 'components/layout/panelBox';
// import PaginationApp from "components/pagination";

// import * as T from "common/types";
import * as S from './styles';

import { ReactSVG } from 'react-svg';
import Gap from 'components/gap';
import DropDown from 'components/form/dropDown';
import { Formik } from 'formik';
import TextInput from 'components/form/textInput';
import { useState } from 'react';
import { SurveyQuestionTypeEnumArray } from 'common/enums';
import { useActions } from 'common/hooks/useActions';
import { toast } from 'common/helpers/toastConfig';
import { ValidationCreateQuestionSurvey } from 'common/validations';
import LineWrappedComponent from 'components/lineWrappedComponent';

interface IProps {
  questions: any[];
  isUpdate: boolean;
}

export default function SurveyCreateQuestions({ questions, isUpdate }: IProps) {
  const [showQuestionForm, setShowQuestionForm] = useState(true);
  const [showQuestionChoicesForm, setShowQuestionChoicesForm] = useState(true);
  const [options, setOptions] = useState<any[]>([]);
  const {
    surveyQuestionAddAction,
    surveyQuestionDeleteAction,
    surveyQuestionEditAction
    // surveyQuestionChoicesEditAction,
    // surveyQuestionChoicesDeleteAction,
    // surveyQuestionChoicesAddAction,
  } = useActions();

  const transformOptions = (options: any) => {
    return options.map((option: any) => ({
      id: option.id,
      translations: [
        {
          language: 'en',
          title: option.en_title
        },
        {
          language: 'ar',
          title: option.ar_title
        }
      ]
    }));
  };

  const revertTransformedData = (transformedData: any) => {
    return transformedData.map((item: any) => {
      const enTranslation = item.translations.find((t: any) => t.language === 'en');
      const arTranslation = item.translations.find((t: any) => t.language === 'ar');

      return {
        id: item.id,
        en_title: enTranslation ? enTranslation.title : '',
        ar_title: arTranslation ? arTranslation.title : ''
      };
    });
  };

  return (
    <S.Content>
      <PanelBoxLayout style={{ padding: '20px 30px', minHeight: '400px' }}>
        <Formik
          initialValues={{
            en_question: '',
            ar_question: '',
            type: '',
            typeTitle: '',
            questions: [],
            // options: [],
            text: '',
            en_choiceText: '',
            ar_choiceText: '',
            editId: null
          }}
          validationSchema={ValidationCreateQuestionSurvey}
          enableReinitialize
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitting(false);
            if (values.type === 'optional' && !options.length) {
              toast({ model: 'error', message: 'Please add a choice!' });
              return;
            }

            if (values.editId) {
              surveyQuestionEditAction({
                type: values.type,
                translations: [
                  {
                    language: 'en',
                    title: values.en_question,
                    text: values.text
                  },
                  {
                    language: 'ar',
                    title: values.ar_question,
                    text: values.text
                  }
                ],
                text: values.text,
                options: transformOptions(options),
                id: values.editId,
                index: questions.length,
                rate: 0,
                typeTitle: values.typeTitle
              });
            } else
              surveyQuestionAddAction({
                id: JSON.stringify(Math.random() * 67),
                translations: [
                  {
                    language: 'en',
                    title: values.en_question,
                    text: values.text
                  },
                  {
                    language: 'ar',
                    title: values.ar_question,
                    text: values.text
                  }
                ],
                options: values.type === 'optional' ? transformOptions(options) : [],
                type: values.type,
                index: questions.length,
                rate: 0,
                typeTitle: values.typeTitle
              });
            resetForm();
            setOptions([]);
            setShowQuestionChoicesForm(false);
          }}
        >
          {({
            values,
            errors,
            touched,
            // handleChange,
            handleSubmit,
            // isSubmitting,
            setValues
          }) => (
            <div className="w-100 h-100 d-flex align-items-start gap-4">
              <div
                className="w-100 h-100"
                style={{ backgroundColor: '#f7f8fc', padding: '12px', borderRadius: '12px' }}
              >
                <S.Head>Questions</S.Head>
                <Gap size="30px" />
                {showQuestionForm ? (
                  <>
                    <DropDown
                      label="Question Type"
                      list={SurveyQuestionTypeEnumArray}
                      placeholder="Question Type"
                      onChange={(e) => {
                        setValues({
                          ...values,
                          typeTitle: e.title,
                          type: e.id as any
                        });
                        if (e.id === 'optional') setShowQuestionChoicesForm(true);
                      }}
                      defaultValue={{ title: values.typeTitle, id: values.type }}
                      key={values.type}
                      message={touched.type && (errors.type as any)}
                      error={errors.type as unknown as boolean}
                      disabled={isUpdate}
                    />
                    <Gap size="20px" />
                    <div className="w-100 d-flex align-items-center gap-4">
                      <TextInput
                        label="English Question Title"
                        name="en_question"
                        value={values.en_question}
                        onChange={(e) => {
                          setValues({ ...values, en_question: e.target.value });
                        }}
                        placeholder="Question"
                        message={touched.en_question && (errors.en_question as any)}
                        error={errors.en_question as unknown as boolean}
                        disabled={isUpdate}
                      />

                      <TextInput
                        label="Arabic Question Title"
                        name="ar_question"
                        value={values.ar_question}
                        onChange={(e) => {
                          setValues({ ...values, ar_question: e.target.value });
                        }}
                        placeholder="يرجى إدخال عنوان الاستطلاع"
                        message={touched.ar_question && (errors.ar_question as any)}
                        error={errors.ar_question as unknown as boolean}
                        disabled={isUpdate}
                      />
                    </div>
                    <Gap size="20px" />
                    <LineWrappedComponent lineHeight="1px">
                      <S.AddOption
                        onClick={() => {
                          if (isUpdate) return;
                          handleSubmit();
                        }}
                      >
                        <ReactSVG
                          src={'/icons/add-square.svg'}
                          beforeInjection={(svg) => {
                            svg.setAttribute('width', '24px');
                            svg.setAttribute('height', '24px');
                          }}
                        />
                        Add Question
                      </S.AddOption>
                    </LineWrappedComponent>
                    {values.type === 'optional' ? (
                      <>
                        <Gap size="20px" />
                        {showQuestionChoicesForm ? (
                          <div className="w-100 d-flex align-items-center gap-4">
                            <TextInput
                              label="English Choice"
                              name="en_choiceText"
                              value={values.en_choiceText}
                              onChange={(e) => {
                                setValues({
                                  ...values,
                                  en_choiceText: e.target.value
                                });
                              }}
                              placeholder="Choice Title"
                              message={touched.en_choiceText && (errors.en_choiceText as any)}
                              error={errors.en_choiceText as unknown as boolean}
                            />

                            <TextInput
                              label="Arabic Choice"
                              name="ar_choiceText"
                              value={values.ar_choiceText}
                              onChange={(e) => {
                                setValues({
                                  ...values,
                                  ar_choiceText: e.target.value
                                });
                              }}
                              placeholder="يرجى إدخال عنوان الاستطلاع"
                              message={touched.ar_choiceText && (errors.ar_choiceText as any)}
                              error={errors.ar_choiceText as unknown as boolean}
                            />
                          </div>
                        ) : (
                          <></>
                        )}
                        <Gap size="20px" />
                        {options.map((choice: any, index: number) => (
                          <div
                            key={index}
                            className="w-100 d-flex align-items-center gap-2 position-relative mb-4"
                            style={{ backgroundColor: '#EEF1F6', padding: '8px', borderRadius: '8px' }}
                          >
                            <TextInput
                              value={choice.en_title}
                              name="en_choice_title"
                              label={`English Choice ${index + 1}`}
                              onChange={(e: any) => {
                                setOptions(
                                  options.map((item: any) => {
                                    return item.id === choice.id
                                      ? {
                                          ...item,
                                          en_title: e.target.value
                                        }
                                      : item;
                                  })
                                );
                              }}
                              placeholder="Enter Choice"
                              message={touched.en_choiceText && (errors.en_choiceText as any)}
                              error={errors.en_choiceText as unknown as boolean}
                            />

                            <TextInput
                              value={choice.ar_title}
                              name="ar_choice_title"
                              label={`Arabic Choice ${index + 1}`}
                              onChange={(e: any) => {
                                setOptions(
                                  options.map((item: any) => {
                                    return item.id === choice.id
                                      ? {
                                          ...item,
                                          ar_title: e.target.value
                                        }
                                      : item;
                                  })
                                );
                              }}
                              placeholder="يرجى إدخال عنوان الاستطلاع"
                              message={touched.ar_choiceText && (errors.ar_choiceText as any)}
                              error={errors.ar_choiceText as unknown as boolean}
                            />

                            <S.DeleteButton
                              style={{
                                width: 35,
                                height: 35,
                                minWidth: 35,
                                position: 'absolute',
                                right: -17,
                                top: -13
                              }}
                              onClick={() => {
                                if (isUpdate) return;
                                setOptions(options.filter((item: any) => item.id !== choice.id));
                              }}
                            >
                              <ReactSVG
                                src="/icons/stroke/trash.svg"
                                beforeInjection={(svg) => {
                                  svg.setAttribute('stroke', `#FF6464`);
                                  svg.setAttribute('width', `20px`);
                                  svg.setAttribute('height', `20px`);
                                }}
                              />
                            </S.DeleteButton>
                          </div>
                        ))}
                      </>
                    ) : (
                      <></>
                    )}
                    <Gap size="20px" />
                  </>
                ) : (
                  <></>
                )}

                {showQuestionChoicesForm && values.type === 'optional' && (
                  <S.AddOption
                    onClick={() => {
                      if (values.en_choiceText.length > 0 && values.ar_choiceText.length > 0) {
                        setOptions([
                          ...options,
                          {
                            id: JSON.stringify(Math.random() * 67),
                            en_title: values.en_choiceText,
                            ar_title: values.ar_choiceText
                          }
                        ]);
                        setValues({
                          ...values,
                          en_choiceText: '',
                          ar_choiceText: ''
                        });
                      }
                    }}
                  >
                    Add Option
                  </S.AddOption>
                )}
              </div>
              <S.QuestionsList>
                <S.Head>Questions List</S.Head>
                <S.List>
                  {questions?.map((item: any) => (
                    <S.ListItem>
                      <S.Grid>
                        <S.Text>
                          <S.Type>{item.typeTitle}</S.Type>
                          {item?.translations?.find((t: any) => t.language === 'en')?.title}
                        </S.Text>
                        <S.EditButton
                          onClick={() => {
                            if (isUpdate) return;
                            setShowQuestionForm(true);
                            if (item.options.length) setShowQuestionChoicesForm(true);
                            setValues({
                              ...values,
                              en_question: item?.translations?.find((t: any) => t.language === 'en')?.title,
                              ar_question: item?.translations?.find((t: any) => t.language === 'ar')?.title,
                              type: item.type,
                              typeTitle: item.typeTitle,
                              editId: item.id
                            });
                            setOptions(revertTransformedData(item.options));
                          }}
                        >
                          <ReactSVG
                            src="/icons/stroke/pen.svg"
                            beforeInjection={(svg) => {
                              svg.setAttribute('stroke', `#8A93AC`);
                              svg.setAttribute('width', `18px`);
                              svg.setAttribute('height', `18px`);
                            }}
                          />
                        </S.EditButton>
                        <S.DeleteButton
                          onClick={() => {
                            if (isUpdate) return;
                            surveyQuestionDeleteAction(item);
                          }}
                        >
                          <ReactSVG
                            src="/icons/stroke/trash.svg"
                            beforeInjection={(svg) => {
                              svg.setAttribute('stroke', `#FF6464`);
                              svg.setAttribute('width', `24px`);
                              svg.setAttribute('height', `24px`);
                            }}
                          />
                        </S.DeleteButton>
                      </S.Grid>
                      <Gap size="5px" />
                      {item?.options?.map((item: any) => (
                        <S.TextChoice>{item?.title}</S.TextChoice>
                      ))}
                    </S.ListItem>
                  ))}
                </S.List>
              </S.QuestionsList>
            </div>
          )}
        </Formik>
      </PanelBoxLayout>
    </S.Content>
  );
}
